import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { getUrlPathWithSuffix, pathNames } from '../../utilities/routing-path-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-payment-cancel-page',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './payment-cancel-page.component.html',
  styleUrl: './payment-cancel-page.component.scss'
})
export class PaymentCancelPageComponent {
  paymentPlansPath: string = getUrlPathWithSuffix(pathNames.paymentPlansPath);

  constructor(
    private router: Router
  ){}

  onSeePlansClicked(){
    this.router.navigate([this.paymentPlansPath]);
  }
}
